import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { NavPayloadAction } from '@carvana/merch-native';
import { datadogRum } from '@datadog/browser-rum';
import { useCallback, useContext, useMemo } from 'react';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import { DATADOG_EVENTS } from '~/constants/flp/datadogEvents';
import { useFinancingContext } from '~/context/flp/FinancingContext';
import { getCvnaIdFinanceFilters } from '~/utilities/flp/getCvnaId';
import {
  ButtonContainer,
  Copy,
  CopyDescription,
  CopyHeading,
  Shop
} from './ShopDown.styles';

const ShopDownButton = ({ index }: any) => {
  const { aggregates } = useFinancingContext();
  const { trackEvent } = useContext(AnalyticsContext);

  const downPaymentInfo = useMemo(
    () => aggregates?.downPaymentBuckets?.[index],
    [aggregates?.downPaymentBuckets, index]
  );

  const url = useMemo(() => {
    const cvnaid = getCvnaIdFinanceFilters({
      downPayment: downPaymentInfo?.downPayment
    });

    return `/cars/filters?cvnaid=${cvnaid}&refSource=financing`;
  }, [downPaymentInfo?.downPayment]);

  const onClick = useCallback(() => {
    datadogRum.addAction(DATADOG_EVENTS.PREQUALIFIED.CLICKS_SHOPBYCASHDOWN, {
      ...downPaymentInfo
    });
    trackEvent(ANALYTICS_EVENTS.PREQUALIFIED.CLICKS_SHOPBYCASHDOWN, {
      ...downPaymentInfo
    });
  }, [downPaymentInfo, trackEvent]);

  return (
    <ButtonContainer
      data-analytics-id="Financing Shop Down Payment Button"
      data-native-payload={JSON.stringify({ action: NavPayloadAction.ViewSrp })}
      href={url}
      onClick={onClick}
      data-testid="shop-down-payment"
    >
      <Copy>
        <CopyHeading>{`Under $${downPaymentInfo?.downPayment.toLocaleString(
          'en-US'
        )} down`}</CopyHeading>
        <CopyDescription>{`${downPaymentInfo?.count.toLocaleString(
          'en-US'
        )} vehicles`}</CopyDescription>
      </Copy>
      <Shop>Shop -&gt;</Shop>
    </ButtonContainer>
  );
};

export default ShopDownButton;
